export default "__VITE_ASSET__1bIveMxX__"